import { useList } from "@inmagik/react-crud"
import { API_URL } from "../../constants"
import { TipoDato } from "../../types"

export function useTipoDatoList(params: Record<string, string> = {}) {
  return useList<TipoDato>(`${API_URL}/tipi-dato`, { query: params })
}
